// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"6d6d8289","977":"83aac2ce"}[chunkId] + ".chunk.js";
};